<template>
  <div id="EPaperManage2">
    <div v-if="EPaperManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <button
          href="#"
          @click="AddEPaper2()"
          class="btn btn-outline-success"
          type="button"
          style="font-size: 14px; text-align: right"
        >
          新增信件
        </button>


      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >


          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="min-width: 2em">序號</b-th>
                <b-th style="min-width: 26em">主旨</b-th>
                <b-th style="min-width: 5em">發送日期</b-th>
                <b-th style="min-width: 2em">是否發送</b-th>
                <b-th style="min-width: 20em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(item, index) in filteredDocs"
                :key="item.eid"
                :index="item.eid"
                :name="item.eid"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: right">
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </b-td>
                <b-td style="text-align: left">
                  {{ item.title }}
                </b-td>
                <b-td style="text-align: left">{{ getToday(item.updateTime) }}</b-td>
                <b-td style="text-align: left">
                  {{ item.send == true ? "已發送" : "未發送" }}
                </b-td>
                <b-td>
                  <button
                    href="#"
                    @click.prevent="EditEPaper2(item.eid)"
                    class="btn btn-outline-info"
                    type="button"
                    style="font-size: 14px"
                  >
                    修改
                  </button>
                  <button
                    href="#"
                    @click.prevent="remove2(item.eid)"
                    class="btn btn-outline-danger"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>

                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>

      <b-modal size="xl" ref="AddEPaper2" hide-footer>
        <template #modal-title> 新增信件 </template>
        <AddEPaper2 @hideModal="hideModal('AddEPaper2')"></AddEPaper2>
      </b-modal>
      <b-modal size="xl" ref="EditEPaper2" hide-footer>
        <template #modal-title> 修改信件 </template>
        <EditEPaper2
          :id="editId"
          @hideModal="hideModal('EditEPaper2')"
        ></EditEPaper2>
      </b-modal>
      <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
          >取消刪除</b-button
        >
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
          >刪除確認</b-button
        >
      </b-modal>
    </div>



  </div>
</template>


<script>
import AddEPaper2 from "@/components/AddEPaper2.vue";
import EditEPaper2 from "@/components/EditEPaper2.vue";
import * as tools from "../tool";
export default {
  name: "EPaperManage",
  data() {
    return {
      courseName: null,
      EPaperManageShow: false,
      eid: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
    };
  },
  components: {
    AddEPaper2,
    EditEPaper2,
  },
  methods: {
    getToday(updateTime) {
      var dd = new Date(updateTime);
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      var hours = dd.getHours().toString().padStart(2, "0");
var minutes = dd.getMinutes().toString().padStart(2, "0");
var seconds = dd.getSeconds().toString().padStart(2, "0");

      return tools.stringFormat("{0}-{1}-{2} {3}:{4}:{5}", yyyy, mm, today, hours, minutes, seconds);
    },


    backCourseList() {
      this.EPaperManageShow = true;
      this.getAllEPaper2();
    },

    getAllEPaper2() {
      let vm = this;
      this.$http
        .get("./WebApi/EconomicDisadvantage/GetAllEPaper2/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            vm.currentPage = 1;
            vm.currentPage2 = 1;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    AddEPaper2() {
      var vm = this;
      vm.$refs["AddEPaper2"].show();
    },
    EditEPaper2(id) {
      var vm = this;
      vm.editId = id;
      vm.$refs["EditEPaper2"].show();
    },
    remove2(eid) {
      this.eid = eid;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },
    hideModal(name) {
      this.$refs[name].hide();
      this.getAllEPaper2();
    },
    confirmRM() {
      //刪除電子報資料
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get("./WebApi/EconomicDisadvantage/RemoveEPaper2/".concat(this.eid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
            vm.getAllEPaper2();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },



  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    filteredDocs2: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created CourseManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.EPaperManageShow = true;
    vm.getAllEPaper2();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
